import createApiServices from './createApiServices'

const prefixURL = 'https://admin.callstack.vn:9909/api'
const api = createApiServices({baseUrl: prefixURL})

export const getUserTransaction = (userName, payload = {}) => {
    return api.makeRequest({
        url: `/billing/searchUserTransaction?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const getUserBilling = (userName, payload = {}) => {
    return api.makeRequest({
        url: `/billing/getUserBilling?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}

export const getUserPackage = (userName, payload = {}) => {
    return api.makeRequest({
        url: `/billing/getUserPackage?userName=${userName}`,
        method: 'POST',
        data: payload
    })
}
